const KEY_PREFIX = "mycoaching_student_onboarding_";

/** Parcours guidé première connexion élève. */
export const ONBOARDING_ENABLED = true;

export function isOnboardingComplete(userId) {
  if (!ONBOARDING_ENABLED || !userId) return true;
  return localStorage.getItem(`${KEY_PREFIX}${userId}`) === "done";
}

export function markOnboardingComplete(userId) {
  if (!userId) return;
  localStorage.setItem(`${KEY_PREFIX}${userId}`, "done");
}

export function resetOnboarding(userId) {
  if (!userId) return;
  localStorage.removeItem(`${KEY_PREFIX}${userId}`);
}